<div class="login-footer">
    <div class="login-footer-section-left">
        <app-login-footer-help></app-login-footer-help>
    </div>
    <div class="login-footer-section-right">
        <app-copyright></app-copyright>
    </div>
</div>